<template>
  <Main>
    <br />
    <sdButton type="primary" class="active" @click="$router.go(-1)">
      <sdFeatherIcons type="chevron-left" />
      {{ $t('common.back') }}
    </sdButton>
    <sdPageHeader :title="$t('pages.developers.detail.title')"> </sdPageHeader>
    <a-row :gutter="25">
      <a-col :md="8" :xs="24">
        <sdCards :title="$t('pages.developers.detail.user-info.title')">
          <BasicFormWrapper>
            <a-form :model="userForm" @finish="handleUserFormFinish">
              <a-row :gutter="25">
                <a-col :md="12" :xs="24">
                  <a-form-item :label="$t('pages.developers.detail.user-info.name')">
                    <a-input v-model:value="userForm.name" required />
                  </a-form-item>
                </a-col>
                <a-col :md="12" :xs="24">
                  <a-form-item :label="$t('pages.developers.detail.user-info.surname')">
                    <a-input v-model:value="userForm.surname" required />
                  </a-form-item>
                </a-col>
              </a-row>

              <a-form-item :label="$t('pages.developers.detail.user-info.email')">
                <a-input v-model:value="userForm.email" required />
              </a-form-item>

              <a-form-item :label="$t('pages.developers.detail.user-info.phone')">
                <a-input v-model:value="userForm.phone" />
              </a-form-item>
              <a-form-item :label="$t('pages.developers.detail.user-info.website')">
                <a-input v-model:value="userForm.website" />
              </a-form-item>
              <a-form-item :label="$t('pages.developers.detail.user-info.about')">
                <a-textarea v-model:value="userForm.biography" :rows="3" />
              </a-form-item>
              <sdButton size="default" htmlType="submit" type="primary"
                >{{ $t('pages.developers.detail.user-info.save-changes') }}
              </sdButton>
            </a-form>
          </BasicFormWrapper>
        </sdCards>
      </a-col>
      <a-col :md="8" :xs="24">
        <sdCards :title="$t('pages.developers.detail.invoice-info.title')">
          <BasicFormWrapper>
            <a-form :model="invoiceForm" @finish="handleInvoiceFormFinish">
              <a-form-Item :label="$t('pages.developers.detail.invoice-info.company-name')">
                <a-input v-model:value="invoiceForm.invoice_company_name" required />
              </a-form-Item>
              <a-row :gutter="16">
                <a-col :span="12"
                  ><a-form-Item :label="$t('pages.developers.detail.invoice-info.name')">
                    <a-input v-model:value="invoiceForm.invoice_firstname" required /> </a-form-Item
                ></a-col>
                <a-col :span="12"
                  ><a-form-Item :label="$t('pages.developers.detail.invoice-info.surname')">
                    <a-input v-model:value="invoiceForm.invoice_lastname" required /> </a-form-Item
                ></a-col>
              </a-row>
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-form-Item :label="$t('pages.developers.detail.invoice-info.country')">
                    <a-input v-model:value="invoiceForm.invoice_country" required />
                  </a-form-Item>
                </a-col>
                <a-col :span="12">
                  <a-form-Item :label="$t('pages.developers.detail.invoice-info.city')">
                    <a-input v-model:value="invoiceForm.invoice_city" required />
                  </a-form-Item>
                </a-col>
              </a-row>
              <a-form-Item :label="$t('pages.developers.detail.invoice-info.zipcode')">
                <a-input v-model:value="invoiceForm.invoice_zip_code" required />
              </a-form-Item>
              <a-form-item :label="$t('pages.developers.detail.invoice-info.address')">
                <a-textarea v-model:value="invoiceForm.invoice_address" :rows="3" required />
              </a-form-item>
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-form-Item :label="$t('pages.developers.detail.invoice-info.tax-office')">
                    <a-input v-model:value="invoiceForm.invoice_tax_office" required />
                  </a-form-Item>
                </a-col>
                <a-col :span="12">
                  <a-form-Item :label="$t('pages.developers.detail.invoice-info.identity-no')">
                    <a-input v-model:value="invoiceForm.identity_number" required />
                  </a-form-Item>
                </a-col>
              </a-row>
              <a-form-Item :label="$t('pages.developers.detail.invoice-info.iban')">
                <a-input v-model:value="invoiceForm.bank_iban" required />
              </a-form-Item>
              <div class="setting-form-actions">
                <sdButton size="default" htmlType="submit" type="primary">
                  {{ $t('pages.developers.detail.invoice-info.save-changes') }}
                </sdButton>
              </div>
            </a-form>
          </BasicFormWrapper>
        </sdCards>
      </a-col>
      <a-col :md="8" :xs="24">
        <sdCards :title="$t('pages.developers.detail.account-info.title')">
          <BasicFormWrapper>
            <a-form :model="accountForm" @finish="handleAccountFormFinish">
              <a-form-item :label="$t('pages.developers.detail.account-info.to-fa-verify')">
                <a-space>
                  <a-switch v-model:checked="accountForm.two_fa_verify" />
                  <span> {{ accountForm.two_fa_verify ? $t('common.open') : $t('common.closed') }}</span>
                </a-space>
              </a-form-item>
              <a-form-item :label="$t('pages.developers.detail.account-info.is-account-active')">
                <a-space>
                  <a-switch v-model:checked="accountForm.is_active" />
                  <span> {{ accountForm.is_active ? $t('common.active') : $t('common.passive') }}</span>
                </a-space>
              </a-form-item>
              <a-form-item :label="$t('pages.developers.detail.account-info.qrcode-created')">
                <a-space>
                  <a-switch v-model:checked="accountForm.qrcode_created" />
                  <span> {{ accountForm.qrcode_created ? $t('common.active') : $t('common.passive') }}</span>
                </a-space>
              </a-form-item>
              <a-form-Item :label="$t('pages.developers.detail.account-info.commission')">
                <a-input v-model:value="accountForm.commission_rate" />
              </a-form-Item>
              <a-form-Item :label="$t('pages.developers.detail.account-info.app-creation-limit')">
                <a-input v-model:value="accountForm.app_creation_limit" />
              </a-form-Item>
              <a-form-Item :label="$t('pages.developers.detail.account-info.perms-group')">
                <a-select v-model:value="accountForm.group_id" style="width: 100%" required>
                  <a-select-option v-for="group in groups" :key="group" :value="group.id">
                    {{ group.title }}
                  </a-select-option>
                </a-select>
              </a-form-Item>
              <div class="setting-form-actions">
                <sdButton size="default" htmlType="submit" type="primary">
                  {{ $t('pages.developers.detail.account-info.save-changes') }}
                </sdButton>
              </div>
            </a-form>
          </BasicFormWrapper>
        </sdCards>
      </a-col>
    </a-row>
  </Main>
</template>

<script>
import { Main } from '../styled';
import { BasicFormWrapper } from '@/view/styled';

export default {
  components: {
    Main,
    BasicFormWrapper,
  },
  data() {
    return {
      user_id: this.$route.params.id,
      userForm: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        website: '',
        biography: '',
      },
      invoiceForm: {
        invoice_company_name: '',
        invoice_firstname: '',
        invoice_lastname: '',
        invoice_country: '',
        invoice_city: '',
        invoice_zip_code: '',
        invoice_address: '',
        invoice_tax_office: '',
        identity_number: '',
        bank_iban: '',
      },
      accountForm: {
        two_fa_verify: false,
        is_active: false,
        qrcode_created: false,
        commission_rate: 0,
        app_creation_limit: 0,
        group_id: 0,
      },
      groups: [],
    };
  },
  methods: {
    getGroups() {
      this.$appAxios.get(this.$endpoints.dev_perms_group_get).then((resp) => {
        this.groups = resp.data.data;
      });
    },
    getUserInfo() {
      this.$appAxios
        .post(this.$endpoints.developer_page_detail, { id: this.user_id })
        .then((response) => {
          if (response.data.status === true) {
            var userInfo = response.data.data;
            console.log(userInfo);
            this.userForm.name = userInfo.name;
            this.userForm.surname = userInfo.surname;
            this.userForm.email = userInfo.email;
            this.userForm.phone = userInfo.phone;
            this.userForm.website = userInfo.website;
            this.userForm.biography = userInfo.biography;

            this.invoiceForm.invoice_company_name = userInfo.invoice_company_name;
            this.invoiceForm.invoice_firstname = userInfo.invoice_firstname;
            this.invoiceForm.invoice_lastname = userInfo.invoice_lastname;
            this.invoiceForm.invoice_country = userInfo.invoice_country;
            this.invoiceForm.invoice_city = userInfo.invoice_city;
            this.invoiceForm.invoice_zip_code = userInfo.invoice_zip_code;
            this.invoiceForm.invoice_address = userInfo.invoice_address;
            this.invoiceForm.invoice_tax_office = userInfo.invoice_tax_office;
            this.invoiceForm.identity_number = userInfo.identity_number;
            this.invoiceForm.bank_iban = userInfo.bank_iban;

            this.accountForm.two_fa_verify = userInfo.two_fa_verify ? true : false;
            this.accountForm.is_active = userInfo.is_active ? true : false;
            this.accountForm.qrcode_created = userInfo.qrcode_created ? true : false;
            this.accountForm.commission_rate = userInfo.commission_rate || 0;
            this.accountForm.app_creation_limit = userInfo.app_creation_limit || 0;
            this.accountForm.group_id = userInfo.group_id;
          }
        })
        .catch((e) => {});
    },
    handleUserFormFinish() {
      this.updateUserInfo(this.userForm, this.$endpoints.developer_page_user);
    },
    handleInvoiceFormFinish() {
      this.updateUserInfo(this.invoiceForm, this.$endpoints.developer_page_invoice);
    },
    handleAccountFormFinish() {
      this.updateUserInfo(this.accountForm, this.$endpoints.developer_accounnt);
    },
    updateUserInfo(form, endpoint) {
      form.id = this.user_id;
      this.$appAxios.post(endpoint, form).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
  },
  created() {
    this.getUserInfo();
    this.getGroups();
  },
};
</script>
